
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RemoveMemberModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      required: true
    },
    fullName: {
      type: String,
      default: undefined
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    removeMember(): void {
      this.$emit('primaryAction', this.email)
    }
  }
})
